import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchOnboardingEnabled, setOnboardingEnabled } from '@/services/onboardingGlobal';

export const ONBOARDING_ENABLED_KEY = 'onboarding-global-enabled';

export function useOnboardingEnabled() {
  return useQuery<boolean>({
    queryKey: [ONBOARDING_ENABLED_KEY],
    queryFn: fetchOnboardingEnabled,
    staleTime: 5 * 60_000,
  });
}

export function useSetOnboardingEnabled() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: setOnboardingEnabled,
    onSuccess: () => qc.invalidateQueries({ queryKey: [ONBOARDING_ENABLED_KEY] }),
  });
}